import { navLinks, siteInfo, categories } from '@/mocks/home';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50 font-heading font-bold text-lg">
                瓜
              </span>
              <span className="font-heading font-bold text-lg text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-xs">
              专注整理娱乐热点的现场影像资料，按专题归档现场视频、录屏片段与直播回放。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">站内导航</h4>
            <ul className="flex flex-col gap-2.5">
              {navLinks.slice(0, 6).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href="#categories"
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center pt-0.5 shrink-0">
                  <i className="ri-mail-line" aria-hidden="true"></i>
                </span>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="hover:text-accent-300 transition-colors break-all cursor-pointer"
                >
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center pt-0.5 shrink-0">
                  <i className="ri-time-line" aria-hidden="true"></i>
                </span>
                <span>每日 09:00 – 23:00 更新维护</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center pt-0.5 shrink-0">
                  <i className="ri-shield-check-line" aria-hidden="true"></i>
                </span>
                <span>内容异议 24 小时内响应处理</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© {year} {siteInfo.name}. 内容仅作娱乐影像资料整理与归档展示。</p>
          <p className="whitespace-nowrap">本站为独立内容整理站点，与任何第三方平台无隶属关系。</p>
        </div>
      </div>
    </footer>
  );
}